import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  withShadow?: boolean;
  withBorder?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingCard',
  props: {
    withShadow: { type: Boolean, default: true },
    withBorder: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["floating-card", { 'with-shadow': _ctx.withShadow, 'with-border': _ctx.withBorder }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})